module.exports = __webpack_public_path__ + "static/media/apple.ee4e2196.jpg";